const APIEndpoint = {
  VERIFT_API: "/v1/user/activate-account",
  SIGN_IN_API: "/v1/auth/login",
  SIGN_OUT_API: "/v1/auth/logout",
  FORGOT_PASSWORD_API: "/v1/auth/forgot-password",

  GET_PROFILE_API: "/v1/s/user/get-profile",
  PUT_PROFILE_API: "/v1/s/user/update-profile",
  GET_ROLE_API: "/v1/s/master/role",
  GET_LINE_OF_WORK_API: "/v1/s/master/line-of-work",
  GET_ESTATE_API: "/v1/s/master/estate",
  CHANGE_PASSWORD_API: "/v1/s/auth/change-password",
  GET_ROLE_LIST: "/role-list",
  SEARCH_USER_MANAGEMENT_API: "/v1/s/user/search-profile",
  SEARCH_USER_REPORT_LOGIN_API: "/v1/s/user/search-report-login",
  CREATE_USER_API: "/v1/s/user/create-profile",
  DELETE_USER_API: "/v1/s/user/delete-profile",
  RESEND_EMAIL_USER_API: "/v1/s/user/resend-mail",

  // Role Management
  SEARCH_ROLE_MANAGEMENT_API: "/v1/s/authorization/search-authorization",
  INIT_AUTHORIZE_ROLE_MANAGEMENT_API: "/v1/s/authorization/init",
  CREATE_ROLE_MANAGEMENT_API: "/v1/s/authorization/create",
  GET_ROLE_MANAGEMENT_API: "/v1/s/authorization/get",
  DELETE_ROLE_MANAGEMENT_API: "/v1/s/authorization",
  UPDATE_ROLE_MANAGEMENT_API: "/v1/s/authorization/update",
  UPDATE_ROLE_USER_STATUS_API: "/v1/s/authorization/update/status",

  // Staff
  SEARCH_STAFF_MANAGEMENT_API: "/v1/s/staff/search",
  CREATE_STAFF_MANAGEMENT_API: "/v1/s/staff",
  UPDATE_STAFF_MANAGEMENT_API: "/v1/s/staff",
  DELETE_STAFF_MANAGEMENT_API: "/v1/s/staff",
  GET_STAFF_BY_ID_API: "/v1/s/staff",
  GET_POSITION_API: "/v1/s/master/position",
  GET_LIST_STAFF_API: "/v1/s/master/staff-name",

  //Customer TouchPoint
  GET_QUARTER: "/v1/s/touchpoint/quarter",
  GET_INSTITUTION: "/v1/s/touchpoint/institution",
  GET_CHANEL: "/v1/s/touchpoint/channel",
  GET_QUESTION: "/v1/s/touchpoint/question",
  GET_STAFFNAME: "/v1/s/master/staff-name",
  GET_POSITION: "/v1/s/master/position",
  GET_DETAILTOUCHPOINT: "/v1/s/touchpoint",

  SEARCH_CURRENT_CUSTORMER_API: "/v1/s/customer/current/search-customer",
  GET_CURRENT_CUSTOMER_BY_ID_FOR_REPORT_INCLUDED_NON_KPI_API: "/v1/s/customer/current/get-for-report",
  GET_CURRENT_CUSTOMER_BY_ID_API: "/v1/s/customer/current/get",
  DELETE_CURRENT_CUSTOMER_API: "/v1/s/customer/current/delete",
  CREATE_CURRENT_CUSTOMER_API: "/v1/s/customer/current/create",
  UPDATE_CURRENT_CUSTOMER_API: "/v1/s/customer/current/update",
  DELETE_CURRENT_CUSTOMER_SUMMARY_VISITOR_API:
    "/v1/s/customer/current/summary/delete",
  EXPORT_REPORT_CURRENT_CUSTOMER: "/v1/s/customer/current/export-report",
  GET_LIST_FACTORY_API: "/v1/s/customer/current/list-factory",

  GET_MASTER_DATA_API: "/v1/s/master",

  POST_TOUCHPOINT: "/v1/s/touchpoint",
  DELETE_TOUCHPOINT: "/v1/s/touchpoint",
  SEARCH_TOUCHPOINT: "/v1/s/touchpoint-filter",
  GET_CHANNEL_HEADER: "/v1/s/touchpoint/question-header",
  GET_AGE: "/v1/s/touchpoint/age",
  GET_NATION: "/v1/s/touchpoint/nationality",
  PUT_TOUCHPOINT: "/v1/s/touchpoint",

  //Customer Future
  SEARCH_FUTURE: "/v1/s/customer/future/search-customer",
  SEARCH_FUTURE_AUTO_COMPLETE: "/v1/s/customer/future/search-auto-complete",
  POST_CREATEFUTURE: "/v1/s/customer/future/create",
  PUT_UPDATEFUTURE: "/v1/s/customer/future/update",
  GET_FUTURE: "/v1/s/customer/future/get",
  DELETE_FUTURE: "/v1/s/customer/future/delete",
  EXPORT_FUTURE: "/v1/s/customer/future/export-report",
  GET_DROPDOWN_MASTER: "/v1/s/master/data",
  GET_DROPDOWN_COUNTRY: "/v1/s/master/country",
  GET_DROPDOWN_VOC: "/v1/s/master/voc",
  GET_DROPDOWN_CURRENT_STATUS: "/v1/s/master/data/current_status",
  GET_LIST_CONTACTS: "/v1/s/customer/future/listContacts",
  
  // Import File //
  DOWNLOAD_IMPORT_FILE: "/v1/s/import-file/download",
  IMPORT_FILE: "/v1/s/import-file/upload",
  IMPORT_FILE_FAIL: "/v1/s/import-file/search-file-fail",



  // UPLOAD & DOWNLOAD
  UPLOAD_FILE_API: "/v1/s/file-storage/upload",
  DOWNLOAD_FILE_API: "/v1/s/file-storage/download",
  IMPORT_FILE_API: "/v1/s/master/data/file_import_list",
  IMPORT_TEMPLATE_API: "/v1/s/master/data/file_template_list",


  //Org Chart File//
  ORGCHART_VERSION_LIST :  "/v1/s/master/file_orgchart_ver_list",
  ORGCHART_DATA_LIST :  "/v1/s/master/file_orgchart_data_list",

  // Export service
  EXPORT_FILE_API: "/v1/s/export-file/export",
  EXPORT_CONFIG_FILE_API: "/v1/s/export-file/export-config",

  //
  GET_COUNTRY_API: "/v1/s/master/country",

  //Customer Stakeholder
  SEARCH_STAKEHOLDER: "/v1/s/stakeholders/search",
  POST_CREATESTAKEHOLDER: "/v1/s/stakeholders/create",
  PUT_UPDATESTAKEHOLDER: "/v1/s/stakeholders/update",
  GET_STAKEHOLDER: "/v1/s/stakeholders",
  DELETE_STAKEHOLDER: "/v1/s/stakeholders",
  GET_DROPDOWN_CONTACT: "/v1/s/master/data/contact_reason",
  GET_DROPDOWN_PERMISSION: "/v1/s/master/data/permission",
  GET_DROPDOWN_POINT_CHANNEL: "/v1/s/master/data/touch_point_channel",
  GET_DROPDOWN_KNOW_CHANNEL: "/v1/s/master/data/known_channel",
  GET_DROPDOWN_ONLINE_CHANNEL: "/v1/s/master/data/contact_online_channel",
  GET_DROPDOWN_OFFLINE_CHANNEL: "/v1/s/master/data/contact_offline_channel",

  // Dashboard
  GET_DROPDOWN_DASHBOARD: "/v1/s/dashboard/list-all",
  GET_DASHBOARD_DETAIL: "/v1/s/dashboard/dash-token",
  GET_DASHBOARD_FUTURE_CUSTOMER_SEGMENT: "/v1/s/dashboard/listFutureCustomerSegment",
  GET_DASHBOARD_CUSTOMER_SEGMENT: "/v1/s/dashboard/listCustomerSegment",
  GET_DASHBOARD_MARKETING_ACTION_PLAN: "/v1/s/dashboard/listProjectProgress",
  GET_DASHBOARD_CRM_PLAN: "/v1/s/dashboard/listCrmProgress",

  UPDATE_DASHBOARD_FUTURECUSTOMER : "/v1/s/customer/future/update-image",

  // Progress Perfomance
  GET_DEPARTMENT: "/v1/s/master/department",
  GET_INDICATOR: "/v1/s/master/indicator",
  GET_INDICATOR_BY_ID_API: "/v1/s/indicators",
  GET_DIVISION: "/v1/s/master/division",
  GET_PROJECT: "/v1/s/master/project",

  // Progress Perfomance - Indicator
  GET_INDICATOR_BY_ID: "/v1/s/indicators",
  GET_INDICATOR_LIST_DATA: "/v1/s/indicators/list",
  PUT_INDICATOR_LIST_DATA: "/v1/s/indicators",
  SEARCH_INDICATOR_DATA: "/v1/s/indicators/search",
  DELETE_INDICATOR_DATA: "/v1/s/indicators",

  // Progress Perfomance - Performance
  GET_PERFOMANCE_BY_ID: "/v1/s/performances",
  GET_PERFOMANCE_LIST_DATA: "/v1/s/performances/list",
  PUT_PERFOMANCE_LIST_DATA: "/v1/s/performances",
  SEARCH_PERFOMANCE_DATA: "/v1/s/performances/search",
  DELETE_PERFOMANCE_DATA: "/v1/s/performances",
  CREATE_PERFOMANCE_API: "/v1/s/performances",

  CREATE_INDICATOR_API: "/v1/s/indicators",
  UPDATE_INDICATOR_API: "/v1/s/indicators",

  GET_YEARLYPLAN_LIST_API: "/v1/s/yearlyPlan/list",
  GET_YEARLYPLAN_BY_ID: "/v1/s/yearlyPlan",
  GET_INDICATOR_BY_YEARLYPLAN: "/v1/s/yearlyPlan/listIndicator",
  GET_LIST_INDICATOR_BY_YEAR: "/v1/s/yearlyPlan/listIndicatorByYear",
  GET_PROJECT_BY_YEARLYPLAN: "/v1/s/yearlyPlan/listProject",
  GET_YEARLY_PROJECT_LIST_API: "/v1/s/yearlyProject/list",
  GET_YEARLY_PROJECT_LIST_YEAR_API: "/v1/s/yearlyProject/listYear",
  GET_LIST_PROJECT_BY_YEAR: "/v1/s/yearlyProject/listProjectByYear",
  GET_PROJECT_BY_YEARLYPROJECT: "/v1/s/yearlyProject/listProject",
  CREATE_PROJECT_API: "/v1/s/yearlyProject",
  UPDATE_PROJECT_API: "/v1/s/yearlyProject",
  UPDATE_YEARLY_INDICATOR_API: "/v1/s/yearlyPlan/saveYearlyIndicator",
  DELETE_YEARLY_PROJECT_DATA: "/v1/s/yearlyProject/master",
  GET_YEARLYPLAN_SEARCH_API: "/v1/s/yearlyPlan/search",

  // Customer Future
  GET_LIST_BY_COMPANY: "/v1/s/customer/future/listByCompany",

  // Competitor
  GET_LIST_COMPETITOR: "/v1/s/competitorInfo/list",
  GET_LIST_COMPETITOR_COUNTRY_API: "/v1/s/competitorInfo/listCountry",
  GET_LIST_COMPETITOR_ฺBY_ID: "/v1/s/competitorInfo",
  SEARCH_COMPETITOR_API: "/v1/s/competitorInfo/search",
  CREATE_COMPETITOR_API: "/v1/s/competitorInfo",
  UPDATE_COMPETITOR_API: "/v1/s/competitorInfo",

  // CustomerCompetior
  CREATE_CUSTOMER_COMPETITOR_API: "/v1/s/customer/customersofcompetitor/create",
  SEARCH_CUSTOMER_COMPETITOR_API: "/v1/s/customer/customersofcompetitor/search-competitor",
  GET_CUSTOMER_COMPETITOR_BY_ID_API: "/v1/s/customer/customersofcompetitor/get",
  PUT_UPDATE_CUSTOMER_COMPETITOR:"/v1/s/customer/customersofcompetitor/update",
  // AreaUsage
  GET_LIST_AREAUSAGE: "/v1/s/areaUsage/list",
  GET_LIST_AREAUSAGE_ฺBY_ID: "/v1/s/areaUsage",
  SEARCH_AREAUSAGE_API: "/v1/s/areaUsage/search",
  CREATE_AREAUSAGE_API: "/v1/s/areaUsage",
  UPDATE_AREAUSAGE_API: "/v1/s/areaUsage",
  DELETE_AREAUSAGE_API: "/v1/s/areaUsage",

  //Autocomplete
  SEARCH_AUTO_COMPLETE: "/v1/s/autoComplete",
  SEARCH_PRODUCT_API: "/v1/s/customer/current/search-product",

  // Visit
  GET_LIST_VISIT_YEAR: "/v1/s/customerVisitPlan/listYear",
  GET_LIST_VISIT: "/v1/s/customerVisitPlan/list",
  GET_LIST_VISIT_ฺBY_ID: "/v1/s/customerVisitPlan",
  SEARCH_VISIT_API: "/v1/s/customerVisitPlan/search",
  CREATE_VISIT_API: "/v1/s/customerVisitPlan",
  UPDATE_VISIT_API: "/v1/s/customerVisitPlan",
  DELETE_VISIT_API: "/v1/s/customerVisitPlan",

  // VocReport
  GET_LIST_WORK_AGE: "/v1/s/vocreport/age",
  GET_LIST_INDUSTRY: "/v1/s/vocreport/industry",
  GET_LIST_FUTURE_INDUSTRY: "/v1/s/vocreport/future_industry",
  GET_LIST_YEAR_OF_BUDGET: "/v1/s/vocreport/yearofbudget",
  GET_LIST_YEAR_OF_BUDGET_FUTURE: "/v1/s/vocreport/yearofbudgetFuture",
  SEARCH_LIST_VOC_REPORT: "/v1/s/vocreport/search-yearOfBudget",
  GET_CURRENT_DETAIL_VOC_REPORT: "v1/s/vocreport/detail",
  GET_FUTURE_DETAIL_VOC_REPORT: "v1/s/vocreport/futuredetail",

  // CurrentCustomerGroupByEstateAndDbdRegister
  SEARCH_CURRENT_CUSTORMER_GroupBy_EstateAndDbd_API: "/v1/s/customer/current/search-customer-group-dbdEstate",
  GET_CURRENT_CUSTOMER_GroupBy_EstateAndDbd_BY_ID_API: "/v1/s/customer/current",
};

export default APIEndpoint;
